import React from 'react';
import FinanceSectionInteractiveWorkspace from './FinanceSectionInteractiveWorkspace';

const FinanceOverviewWorkspace = ({ isDarkMode = false }) => (
  <FinanceSectionInteractiveWorkspace isDarkMode={isDarkMode} sectionKey="overview" />
);

export default FinanceOverviewWorkspace;
